import React, { useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getTextColor } from "../../../utils/utils";
import { StateProvider } from "../../SharedContext";
import { RightArrow } from "../../Svgs/right-arrow";
import { DownArrow, UpArrow } from "../../../../components/atoms";
import { STATIC_KEYWORDS } from "../../../../constants";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../ga-utils";

import "./key-events.m.css";

const KeyEventCards = (props) => {
  const { config, index, cardLength, card = {}, slug, loadCards, showLoadMore, scrollToCard, story, qtConfig } = props;
  const { "story-elements": storyElements = [], id } = card;
  const { theme, mountAt = "" } = config;
  const textColor = getTextColor(theme);
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const lastElement = index === cardLength - 1;
  // Function to track key event clicks
  const trackKeyEventClick = (linkPosition) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(
        window.location,
        pageType,
        qtConfig,
        story
      );

      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: "live_blog_key_event_clicks",
        link_position: linkPosition,
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
    <>
      <div
        aria-label="event-title"
        styleName={`event-title-wrapper ${textColor}`}
        onClick={() => {
          trackKeyEventClick(index + 1);
          scrollToCard(card.id);
        }}
      >
        <div>
          {storyElements.map(
            (element, index) =>
              element.type === "title" && (
                <div key={index} styleName="event-title">
                  <h5>{element.text}</h5>
                  <div>
                    <RightArrow color="#C6554F" />
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </>
  );
};

KeyEventCards.propTypes = {
  card: PropTypes.shape({
    "card-added-at": PropTypes.number,
    "story-elements": PropTypes.array,
    id: PropTypes.string,
  }),
  config: PropTypes.object,
  slug: PropTypes.string,
  story: PropTypes.object,
  elements: PropTypes.array,
  index: PropTypes.number,
  cardLength: PropTypes.number,
  loadCards: PropTypes.bool,
  showLoadMore: PropTypes.bool,
  scrollToCard: PropTypes.func,
};

const KeyEvents = ({ story = {}, config = {}, showLoadMore = true, publishedDetails = {}, scrollToCard }) => {
  const keyEventsTitle = get(publishedDetails, ["localizedKeyEvents"], "Key Events") || "Key Events";
  const cards = get(story, ["cards"], []);
  const { theme, initialLoadCount = 3 } = config;
  const textColor = getTextColor(theme);
  const [initialCount, updatedCount] = useState(initialLoadCount);
  const cardsWithKeyEvents = cards.filter((card) => get(card.metadata, ["attributes", "key-event"]));
  const lastElement = cardsWithKeyEvents.length > initialCount;
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));

  const onClick = () => {
    updatedCount(initialCount + initialLoadCount);
  };

  const onClickCollapse = () => {
    updatedCount(initialLoadCount);
  };

  if (cardsWithKeyEvents.length < 1) {
    return null;
  }

  const showAllCards = !showLoadMore ? cardsWithKeyEvents.slice(0, 4) : cardsWithKeyEvents.slice(0, initialCount);

  const keyEvents = showAllCards.map((card, index, source) => (
    <KeyEventCards
      cardLength={source.length}
      card={card}
      key={card.id}
      slug={story.slug}
      config={config}
      index={index}
      loadCards={lastElement}
      showLoadMore={showLoadMore}
      scrollToCard={scrollToCard}
      story={story}
      qtConfig={qtConfig}
    />
  ));

  return (
    <div className="arrow-component" style={{ background: theme }} styleName={`container ${textColor}`}>
      <h4>{keyEventsTitle}</h4>
      <div styleName="cards-wrapper">{keyEvents}</div>
      {showLoadMore && lastElement ? (
        <span styleName="see-more" onClick={onClick}>
          {STATIC_KEYWORDS.SEE_MORE} <DownArrow />
        </span>
      ) : cardsWithKeyEvents.length > 3 ? (
        <span styleName="see-more" onClick={onClickCollapse}>
          {STATIC_KEYWORDS.SEE_LESS} <UpArrow />
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

KeyEvents.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  showLoadMore: PropTypes.bool,
  publishedDetails: PropTypes.object,
  scrollToCard: PropTypes.func,
};

export default StateProvider(KeyEvents);
